import React from 'react'
import { ITag } from '@api/types'
import MultiSelectComponent from './MultiSelectComponent'
import api from '@api'
import { Classes } from '@blueprintjs/core'
import { HighlightedText } from '..'
import css from './multiSelect.module.scss'
import { ItemProps } from './GenericSelectWithInfiniteScroll'

interface MultiWPGSelectProps {
  values: ITag[] | undefined
  onChange: (items: ITag[] | undefined) => void
  onCreate: (item: string) => void
  onClear: () => void
}

export function EmployeeTagItem({ type, data, refItem, query }: ItemProps<ITag>) {
  if (type === 'skeleton') {
    return (
      <div className="flex items-center py-1" style={{ minWidth: 300 }}>
        <div className="ml-2">
          <span className={Classes.SKELETON}>tag name</span>
        </div>
      </div>
    )
  }

  const { name } = data as ITag

  return (
    <div ref={refItem} className="flex items-center py-1 truncate">
      <div className="ml-2 font-medium truncate">
        <HighlightedText query={query} text={name} />
      </div>
    </div>
  )
}

export default function MultiAssetsSelect({
  values,
  onChange,
  onCreate,
  onClear,
}: MultiWPGSelectProps) {
  return (
    <MultiSelectComponent
      title=""
      customClass={{ multiCustomClass: css.multiSelectCustomClass }}
      values={values ?? []}
      list={api.asset.fetch}
      icon={null}
      itemRenderer={EmployeeTagItem}
      onChange={onChange}
      multi
      canCreate
      onCreate={onCreate}
      onClear={onClear}
    />
  )
}
